import type { PlanEvent } from "../../../../convex/lib/moneyPlan";

export const paymentId = (event: PlanEvent) =>
  `${event.key}:${event.eventDate}`;

export const fundingLabel = (event: PlanEvent) => event.accountId
  ? event.accountLabel || "Assigned account"
  : event.accountLabel.trim() ? `${event.accountLabel} (unlinked)` : "Funding account not set";

/** Scheduled dollars only; income never offsets the amount to reserve. */
export function paymentReserve(events: PlanEvent[], excluded: Set<string>) {
  const payments = events.filter((e) => e.kind === "payment" && !e.completed);
  const selected = payments.filter((e) => !excluded.has(paymentId(e)));
  const banks = new Map<
    string,
    { label: string; cents: number; count: number; unassigned: boolean }
  >();
  for (const e of selected) {
    const key = e.accountId || `unlinked:${e.accountLabel.trim()}`;
    const bank = banks.get(key) || {
      label: fundingLabel(e),
      cents: 0,
      count: 0,
      unassigned: !e.accountId,
    };
    bank.cents += Math.round(e.amount * 100);
    bank.count++;
    banks.set(key, bank);
  }
  return {
    payments,
    selected,
    banks: [...banks.values()],
    total:
      selected.reduce((sum, e) => sum + Math.round(e.amount * 100), 0) / 100,
  };
}
